import styled from "styled-components";

export const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
`

export const Content = styled.div`
  border-radius: 0.5rem;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 30rem;
  height: 20rem;
  background: var(--black-100);

  h2 {
    text-align: center;
  }

  button {
    width: 15rem;
    height: 4rem;
    transition: all 0.3s ease-in-out;
    background: var(--black-300);
    border: 1px solid var(--black-300);
    font-size: 1.1rem;
    color: var(--white);
    font-weight: 500;
    font-family: DM Sans !important;

    &:hover {
      border-color: #fff;
    }
  }
`